import React, { Component } from "react";
import { MdEdit } from "react-icons/md";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import fix_numbers from "../../../../base/utils/fix_numbers";
import { confirm, login } from "../../../auth/services";

class EditCallCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editPhoneModal: false,
      codeModal: false,
      pending: false,
      err406: false,
      phone: this.props.phone,
      loginToken: "",
      expire_time: "",
      code: "",
      shopUid: window.location.pathname.split("/")[2],
    };
    this.codeInput = React.createRef();
  }
  submitPhone() {
    this.setState({ pending: true });
    login(fix_numbers.fixNumbers(this.state.phone), "users").then(
      (loginRes) => {
        if (loginRes && loginRes.status === 200)
          this.setState(
            {
              loginToken: loginRes.data.token,
              expire_time: loginRes.data.expire_time,
              editPhoneModal: false,
              codeModal: true,
              pending: false,
            },
            () => {
              var timer = setInterval(() => {
                this.state.expire_time > 0
                  ? this.setState({
                      expire_time: Number(this.state.expire_time) - 1,
                    })
                  : clearInterval(timer);
              }, 1000);
            }
          );
        else {
          this.setState({ pending: false });
          Swal.fire({
            text: "شماره نامعتبر است",
            icon: "error",
            confirmButtonText: "تایید",
          });
        }
      }
    );
  }
  submitCode() {
    this.setState({ pending: true, err406: false });
    confirm(
      fix_numbers.fixNumbers(this.state.code),
      this.state.loginToken,
      "users"
    ).then((res) => {
      if (res.response && res.response.status && res.response.status === 406) {
        this.setState({ err406: true });
        this.codeInput.current.classList.add("border-danger", "text-danger");
      }
      if (res && res.status === 200) {
        this.setState({ err406: false, codeModal: false });
        this.props.setPhone(this.state.phone);
      }
      this.setState({ pending: false });
    });
  }
  render() {
    return (
      <section>
        <div className="col-12 px-0 mt-4">
          <h2 className="fw-bold fs-4 mb-3">شماره پشتیبانی فروشگاه</h2>
          <span className="ms-3 fs-5 color-main fw-bold">
            {this.props.phone}
          </span>
          <MdEdit
            className="text-secondary"
            size={26}
            onClick={() => this.setState({ editPhoneModal: true })}
          />
        </div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.state.codeModal}
          toggle={() => this.setState({ codeModal: false })}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 mt-4 text-center px-0">
              <h6 className="card-title my-3 text-center">
                کد ۴ رقمی ارسال شده به
                <span className="color-main">
                  {" " + this.state.phone + " "}
                </span>
                را وارد کنید
              </h6>
              <p className="fs-2 fw-bolder">
                {this.state.expire_time === 0 ? (
                  <button
                    className="btn fs-6 color-main"
                    onClick={() => this.submitPhone()}
                  >
                    ارسال دوباره کد
                  </button>
                ) : (
                  ~~(this.state.expire_time / 60) +
                  ":" +
                  (this.state.expire_time % 60 < 10
                    ? "0" + (this.state.expire_time % 60)
                    : this.state.expire_time % 60)
                )}
              </p>
              <input
                ref={this.codeInput}
                className="form-control mb-2 text-center rounded14 w-100 bg-gray rounded12 fs-3 mt-4"
                autoFocus={true}
                type="tel"
                dir="ltr"
                placeholder=" -  -  -  - "
                onChange={(e) => this.setState({ code: e.target.value })}
                maxLength="4"
                value={this.state.code}
              />
              {this.state.err406 && (
                <p className="text-danger fs-6 text-center py-2">
                  کد وارد شده اشتباه است
                </p>
              )}
              <button
                className="btn bg-disabled py-2-3 bg-color-main fs-6 text-white w-100 rounded28 border-0 color-white btn-lg mt-3 mb-3"
                type="button"
                disabled={this.state.pending || this.state.code.length !== 4}
                onClick={() => this.submitCode()}
              >
                {this.state.pending ? (
                  <span
                    className="spinner-border spinner-border-sm text-white"
                    role="status"
                    style={{ verticalAlign: "middle" }}
                    aria-hidden="true"
                  />
                ) : (
                  <b>ثبت</b>
                )}
              </button>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.state.editPhoneModal}
          toggle={() => this.setState({ editPhoneModal: false })}
        >
          <ModalBody className="row mx-0 p-4">
            <input
              placeholder="شماره تماس"
              type="tel"
              dir={this.state.phone ? "ltr" : "rtl"}
              onFocus={(e) => {
                e.target.dir = "ltr";
                e.target.placeholder = "";
              }}
              maxLength="11"
              value={this.state.phone}
              onChange={(e) => this.setState({ phone: e.target.value })}
              className="rounded14 w-100 form-control p-3"
            />
            <p className="fw-bold py-3">
              شماره مورد نظر را وارد کنید سپس کد فعال سازی برای شما پیامک خواهد
              شد.
            </p>
            <button
              disabled={
                !this.state.phone ||
                !this.state.phone.startsWith("09") ||
                this.state.phone.length !== 11 ||
                this.state.pending
              }
              className="w-100 btn rounded28 mt-2 py-2-3 bg-color-main text-white bg-disabled"
              onClick={() => this.submitPhone()}
            >
              {this.state.pending ? (
                <span
                  className="spinner-border spinner-border-sm text-white"
                  style={{ verticalAlign: "middle" }}
                />
              ) : (
                <b>ورود</b>
              )}
            </button>
          </ModalBody>
        </Modal>
      </section>
    );
  }
}

export default EditCallCenter;
